import FsLightbox from 'fslightbox-react'
import React from 'react'
// import { Photo, Video } from 'types'
// import MultiActionBar from './multi-action-bar'

interface Props {
  sources: any
  type: string
  toggleEvent: any
  data: any
  slide: number
  index: number
}

const fsGallery = ({ sources, type, toggleEvent, data, slide = 1, index = 0 }: Props) => {
  return type === 'image' || type === 'blueprint' || type === 'tour' || type === 'video' ? (
    <>
      <FsLightbox
        key={index}
        slide={slide}
        toggler={toggleEvent}
        sources={sources.map((element: any, index: number) => (
          <div key={index}>
            {type === 'image' || type === 'blueprint' ? (
              <img src={element.image} />
            ) : (
              <iframe
                className={'iframe-width ' + type}
                allowFullScreen
                src={element.player_url}
                style={{ width: '70vw', height: '80vh' }}
                frameBorder={0}
              />
            )}
          </div>
        ))}
      />
    </>
  ) : (
    ''
  )
}

export default fsGallery
